import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DecoderDto, DecoderResponseDto } from '../types/dtos/decoder.dto';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class DecoderService extends BaseService {
  private _decoderSubject: BehaviorSubject<DecoderDto[]> = new BehaviorSubject<DecoderDto[]>([]);
  public decoders$: Observable<DecoderDto[]> = this._decoderSubject.asObservable();

  constructor(
    private readonly _httpClient: HttpClient,
  ) {
    super();
    this.fetchDecoders();
  }

  public fetchDecoders(): void {
    this._httpClient.get<DecoderResponseDto>(`${ this._baseUrl }/decoders`)
      .subscribe({
        next: (result: DecoderResponseDto) => {
          let decoders: DecoderDto[] = result.data ?? [];

          if (!decoders) return;

          this._decoderSubject.next(decoders);
        },
        error: (error) => console.error('Error fetching decoders:', error),
      });
  }

  public getDecoderById(id: number): DecoderDto | null {
    return this._decoderSubject.value.find((d: DecoderDto) => d.id === id) || null;
  }
}
